import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Story from "@/pages/Story";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import MyData from "@/pages/MyData";
import Admin from "@/pages/Admin";
import BlogPost from "@/pages/BlogPost";
import BlogIndex from "@/pages/BlogIndex";
import PromoCoussin from "@/pages/PromoCoussin";
import MetaPixelRouteTracker from "@/components/MetaPixelRouteTracker";

import { LangProvider } from "@/context/LangContext";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LangProvider>
          <CartProvider>
            <BrowserRouter>
              <MetaPixelRouteTracker />
              <Routes>
                <Route path="/admin" element={<Admin />} />
                <Route path="/promo-coussin" element={<PromoCoussin />} />
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/product/:slug" element={<Product />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/story" element={<Story />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/legal/:slug" element={<Legal />} />
                  <Route path="/me/data" element={<MyData />} />
                  <Route path="/blog" element={<BlogIndex />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </LangProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
